module.exports = __webpack_public_path__ + "static/media/logos_payments.778c9219.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment-methods/logos_payments.png
// module id = 1305
// module chunks = 0